var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFireFill = function SvgFireFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.911 2.04c-.466.338-3.578 2.732-3.578 6.626a4.666 4.666 0 0 0 4.614 4.667 2.667 2.667 0 0 1-2.583-3.077C5.588 8.754 6.97 7.478 7.64 6.94a.57.57 0 0 1 .722 0c.669.538 2.051 1.814 2.275 3.316l.003.023q.027.19.028.388a2.667 2.667 0 0 1-2.614 2.666 4.666 4.666 0 0 0 4.614-4.627v-.04c-.018-2.827-1.93-4.37-2.28-4.627a.09.09 0 0 0-.108 0c-.14.103-.53.412-.948.926a.104.104 0 0 1-.174-.021C8.371 3.28 7.283 2.272 7.026 2.047a.09.09 0 0 0-.115-.006"
  })));
};
export default SvgFireFill;